import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';
import { provideStore } from '@ngxs/store';
import { APP_CONFIG } from '@nha/config/interfaces/iapp-settings.interface';
import { Environments } from '@nha/enums/environment.enum';
import { provideMonitoring } from '@nha/monitoring/monitoring.provider';
import { AcademicYearState } from './app/academic-year/academic-year.state';
import { AppComponent } from './app/app.component';
import { ChildState } from './app/child/child.state';
import { GuardianState } from './app/guardian/guardian.state';
import { NearbySchoolsState } from './app/nearby-schools/nearby-schools.state';
import { DotNetDatePipe } from './app/pipes/dot-net-date.pipe';
import { FullNamePipe } from './app/pipes/full-name.pipe';
import { PossessivePipe } from './app/pipes/possessive.pipe';
import { ContentService } from './app/services/content.service';
import { SaveService } from './app/services/save.service';
import { RootState } from './app/store/root.state';
import { TermsConditionsState } from './app/terms-conditions/terms-conditions.state';

fetch(`${window['applicationAppSettingPathOverride'] ?? ''}assets/app-settings.json`)
	.then((response) => response.json())
	.then((config) => {
		if (config.env === Environments.PROD) {
			enableProdMode();
		}

		bootstrapApplication(AppComponent, {
			providers: [
				{ provide: APP_CONFIG, useValue: config },
				provideMonitoring({
					name: 'application',
					parentApplication: 'School Sites'
				}),
				provideStore([RootState, AcademicYearState, GuardianState, ChildState, NearbySchoolsState, TermsConditionsState], {
					developmentMode: false
				}),
				withNgxsFormPlugin(),
				withNgxsReduxDevtoolsPlugin({ disabled: config.env === Environments.PROD }),
				importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule),
				ContentService,
				SaveService,
				FullNamePipe,
				PossessivePipe,
				DotNetDatePipe,
				{
					provide: APP_BASE_HREF,
					useValue: './'
				},
				provideHttpClient(withInterceptorsFromDi())
			]
		});
	});
